export default {
  onSearching: 'Loading...',
  noContacts: 'No records found.',
} as const;
